import React from 'react';

import PropTypes from 'prop-types';

import DropdownMenuList from './DropdownMenuList';
import DropdownTrigger from './DropdownTrigger';
import { dropdownSelectStyles } from './dropdownSelectStyles';
import { useDropdown } from './useDropdown';

function DropdownSelect({
    value,
    options = [],
    onChange,
    renderTrigger,
    renderOption,
    menuTitle,
    className,
    children,
    id = 'dropdown-select',
    showActiveState = false,
}) {
    const classes = dropdownSelectStyles();
    const { anchorEl, open, handleOpen, handleClose, closeMenu } = useDropdown();

    const handleSelect = (option) => {
        closeMenu();
        if (onChange) onChange(option);
    };

    return (
        <>
            <DropdownTrigger
                id={id}
                open={open}
                onClick={handleOpen}
                className={className}
                value={value}
                renderTrigger={renderTrigger}
            />
            <DropdownMenuList
                id={id}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                classes={classes}
                menuTitle={menuTitle}
                options={options}
                value={value}
                showActiveState={showActiveState}
                renderOption={renderOption}
                onSelect={handleSelect}
                closeMenu={closeMenu}
            >
                {children}
            </DropdownMenuList>
        </>
    );
}

DropdownSelect.propTypes = {
    value: PropTypes.any,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string,
            className: PropTypes.string,
        })
    ),
    onChange: PropTypes.func,
    renderTrigger: PropTypes.func,
    renderOption: PropTypes.func,
    menuTitle: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.func,
    id: PropTypes.string,
    showActiveState: PropTypes.bool,
};

export default DropdownSelect;
